import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {
      hasError: true,
      errorMessage: error.message
    };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error)
    console.log(errorInfo)

    // Report to New Relic when available so client-side crashes are visible in
    // production (we have no frontend Sentry). Guarded so it is a no-op when the
    // agent hasn't loaded.
    if (typeof window !== 'undefined' && window.newrelic) {
      try {
        window.newrelic.noticeError(error, {
          componentStack: errorInfo?.componentStack,
          boundary: this.props.name || 'ErrorBoundary'
        })
      } catch (e) {
        // Never let error reporting throw from within the boundary.
      }
    }
  }

  render() {
    if (this.state.hasError) {
      // Allow callers to supply a custom fallback. Supports either a render
      // function (receives the error message) or a plain node. Falls back to
      // the original inline message to preserve existing behavior.
      const { fallback } = this.props
      if (typeof fallback === 'function') {
        return fallback(this.state.errorMessage)
      }
      if (fallback) {
        return fallback
      }

      return (
        <React.Fragment>
          <h1 style={{ marginBottom: '16px', paddingTop: '16px'}}>Something went wrong.</h1>
          {this.state.errorMessage && (<p style={{ color: 'red' }}>{this.state.errorMessage}</p>)}
        </React.Fragment>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary
